import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';
import { Order } from '@api/Orders/Order';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';

const env = 'production';

export default {
    async createQuote(order: Order, branchOffice: BranchOffice, environment: string = env): Promise<any> {
        try {
            const response = await axiosPrivate.post('/uber/createQuote', { order, branchOffice, environment });
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.details || 'Error al cotizar con Uber';
        }
    },
    async createDelivery(
        order: Order,
        branchOffice: BranchOffice,
        quoteId: string,
        environment: string = env
    ): Promise<void> {
        try {
            await axiosPrivate.post('/uber/createDelivery', { order, branchOffice, quoteId, environment });
        } catch (error: any) {
            throw error.response?.data?.details || 'Error al crear envío en Uber';
        }
    },
    async getDelivery(deliveryId: string, environment: string = env): Promise<any> {
        try {
            const response = await axiosPrivate.post('/uber/getDelivery', { deliveryId, environment });
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.details || 'Error al consultar Uber';
        }
    },
    async cancelDelivery(deliveryId: string, environment: string = env): Promise<void> {
        try {
            await axiosPrivate.post('/uber/cancelDelivery', { deliveryId, environment });
        } catch (error: any) {
            throw error.response?.data?.details || 'Error al cancelar Uber';
        }
    }
};
